import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type Severity = 'success' | 'info' | 'warning' | 'error';

const application = createSlice({
  name: 'application',
  initialState: {
    redirectTo: '',
    message: '',
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    messageSeverity: <'default' | 'error' | 'success' | 'warning' | 'info' | undefined>{},
    isUiBlocked: false,
    fetching: false
  },
  reducers: {
    setRedirectTo(state, action: PayloadAction<string>) {
      state.redirectTo = action.payload;
    },
    cleanRedirectTo(state) {
      state.redirectTo = '';
    },
    blockUI(state) {
      state.isUiBlocked = true;
    },
    unblockUI(state) {
      state.isUiBlocked = false;
    },
    displayMessage(state, action: PayloadAction<Message>) {
      state.message = action.payload.message;
      state.messageSeverity = action.payload.severity;
    },
    hideMessage(state) {
      state.message = '';
    },
    startFetching(state) {
      state.fetching = true;
    },
    finishFetching(state) {
      state.fetching = false;
    }
  }
});

export interface Message {
  message: string;
  severity: 'success' | 'info' | 'warning' | 'error' | undefined;
}
export const {
  setRedirectTo,
  cleanRedirectTo,
  blockUI,
  unblockUI,
  displayMessage,
  hideMessage,
  startFetching,
  finishFetching
} = application.actions;
export default application.reducer;
